import React, { useRef, useState } from 'react';
import { SurveyHubHero } from './SurveyHubHero';
import '../survey-hub.css';

interface Props {
  onAcceptMapping: (questions: import('../types').QuestionConfig[], audience: string, language: string) => void;
  onBack: () => void;
  onOpenMapping?: (payload: { paste: string; fileName: string | null }) => void;
}

const SAMPLE_PASTE = `1. Укажите ваш курс обучения.
2. Насколько понятен индивидуальный план? Варианты: Полностью / Частично / Пока непонятен.
3. Какие сложности возникли в начале учебного года?
4. Оцените доступность консультаций по шкале 1–5.
5. Какие направления поддержки вам нужны? Выберите несколько.
6. Оцените направления поддержки: публикации / стажировка / практика.
7. Дата последней консультации.`;

/** Import ready survey — template importView(). */
export const ImportSurveyView: React.FC<Props> = ({ onAcceptMapping, onBack, onOpenMapping }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string | null>(null);
  const [paste, setPaste] = useState(SAMPLE_PASTE);

  const goMapping = () => {
    if (onOpenMapping) {
      onOpenMapping({ paste, fileName });
      return;
    }
    // fallback: jump straight to builder via accept with empty parse
    onAcceptMapping([], 'Докторанты · 1 курс', 'RU');
  };

  return (
    <div className="survey-hub-content">
      <SurveyHubHero
        title="Импорт готового опроса"
        description="Можно загрузить Word, Excel или текст, либо вставить готовые вопросы. Система распознает структуру и предложит сопоставление полей."
      />

      <section className="survey-hub-panel">
        <header>
          <div className="grow">
            <h3>Источник вопросов</h3>
            <p>Импорт готового опроса</p>
          </div>
          <span className="survey-hub-chip">DOCX · XLSX · TXT</span>
        </header>
        <div className="survey-hub-drop">
          <span className="fileicon" aria-hidden="true">
            📄
          </span>
          <div>
            <strong>{fileName || 'Файл не выбран'}</strong>
            <small>Выберите файл — название и тип появятся здесь.</small>
          </div>
          <label className="survey-hub-btn primary">
            Выбрать файл
            <input
              ref={inputRef}
              type="file"
              accept=".doc,.docx,.xls,.xlsx,.txt,.csv"
              hidden
              onChange={(e) => {
                const f = e.target.files?.[0];
                setFileName(f?.name || null);
              }}
            />
          </label>
        </div>

        <div className="survey-hub-field full" style={{ marginTop: 12 }}>
          <label>Или вставьте вопросы</label>
          <textarea value={paste} onChange={(e) => setPaste(e.target.value)} rows={10} />
        </div>

        <div className="survey-hub-actions">
          <button type="button" className="survey-hub-btn" onClick={onBack}>
            ← Назад
          </button>
          <button type="button" className="survey-hub-btn primary" onClick={goMapping}>
            Распознать структуру →
          </button>
        </div>
      </section>
    </div>
  );
};
